// Canonical origin. www.orinaenterprise.com and http:// 301-redirect here, so
// every canonical, og:url, schema url and sitemap entry uses this host.
export const SITE = "https://orinaenterprise.com";

// Each route is prerendered to <route>/index.html (scripts/prerender.js), which
// Netlify serves at "/route/" and 301-redirects "/route" to. Canonical URLs and
// internal links therefore end in a slash.
export const withSlash = (path = "/") => {
  const [, base = "/", rest = ""] = path.match(/^([^?#]*)(.*)$/) || [];
  if (base === "/" || base.endsWith("/") || /\.[a-z0-9]+$/i.test(base)) return base + rest;
  return `${base}/${rest}`;
};

export const canonicalFor = (path = "/") => `${SITE}${withSlash(path.split(/[?#]/)[0] || "/")}`;

export const abs = (url) => (!url ? url : url.startsWith("http") ? url : `${SITE}${url.startsWith("/") ? "" : "/"}${url}`);
